// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const coverage = [
    "Curățenie în depozite logistice și centre de distribuție",
    "Curățenie în hale industriale și spații de producție",
    "Întreținerea pardoselilor industriale prin spălare mecanizată și degresare",
    "Curățarea zonelor de lucru, căilor de acces și platformelor industriale",
    "Curățenie în jurul utilajelor și echipamentelor",
    "Colectarea și gestionarea deșeurilor nepericuloase",
    "Curățarea zonelor administrative adiacente: birouri, vestiare și grupuri sanitare",
    "Servicii speciale adaptate cerințelor operaționale ale clientului",
];

function TestimonialsHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Cum lucrăm
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4} sx={{ textWrap: "pretty" }}>
                        Lucrăm pe bază de evaluare inițială, proceduri adaptate și planificare
                        operațională, pentru a asigura rezultate constante și sigure în spații
                        industriale de mari dimensiuni.
                    </MKTypography>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Ce acoperim
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={0}>
                        {coverage.map((item) => (
                            <MKTypography
                                component="li"
                                variant="body1"
                                color="text"
                                mb={1.5}
                                key={item}
                                sx={{ textWrap: "pretty" }}
                            >
                                {item}
                            </MKTypography>
                        ))}
                    </MKBox>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default TestimonialsHome;
